import React, { FC, Suspense } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { UserContextProvider } from '@blocs.auth';
import { FeatureExperimentProvider } from '@blocs.features-experiments';
import { AppKey, InternationalizationProvider } from '@blocs.i18n';
import ImpactedServiceAlert from '@blocs.impacted-service-alert';
import { MaintenanceGuard } from '@blocs.maintenance';
import { Loading } from '@minecraft.loader';
import MetaData from '@minecraft.meta-data';
import { CoreTheme } from '@minecraft.themes';
import { WindowWidthContext } from '@minecraft.utils';
import createApolloClient from 'lib/apollo';
import Routes from 'src/routes';

const AppGlobalStyles = createGlobalStyle`
  html, body {
    font-family: 'IBM Plex Sans', sans-serif;
  }
`;

const App: FC = () => {
  const client = createApolloClient();

  return (
    <Suspense fallback={<Loading />}>
      <InternationalizationProvider appName={AppKey.PUBLIC} namespaces={['public']}>
        <FeatureExperimentProvider>
          <ApolloProvider client={client}>
            <UserContextProvider>
              <ThemeProvider theme={CoreTheme}>
                <AppGlobalStyles />
                <MetaData />
                <ImpactedServiceAlert />
                <MaintenanceGuard routes={Routes} />
              </ThemeProvider>
            </UserContextProvider>
          </ApolloProvider>
        </FeatureExperimentProvider>
      </InternationalizationProvider>
    </Suspense>
  );
};

export default WindowWidthContext.withWidthDataProvider(React.memo(App));
